import { callGet, callPost } from '../../services/axios'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import {
	GET_ALL_USERS_START,
	GET_ALL_USERS_SUCCESS,
	GET_ALL_USERS_FAILED,
	GET_DOMAIN_USERS_START,
	GET_DOMAIN_USERS_SUCCESS,
	GET_DOMAIN_USERS_FAILED,
	GET_RECENTLY_VIEWED_DATA_START,
	GET_RECENTLY_VIEWED_DATA_SUCCESS,
	GET_RECENTLY_VIEWED_DATA_FAILED,
	GET_RECENT_KEYWORDS_START,
	GET_RECENT_KEYWORDS_SUCCESS,
	GET_RECENT_KEYWORDS_FAILED,
	GET_CALLER_USERS_START,
	GET_CALLER_USERS_SUCCESS,
	GET_CALLER_USERS_FAILED,
	// DELETE_USER_FROM_USER_MANAGEMENT_START,
	// DELETE_USER_FROM_USER_MANAGEMENT_SUCCESS,
	// DELETE_USER_FROM_USER_MANAGEMENT_FAILED,
	// DELETE_DOMAIN_FROM_USER_ROLE_START,
	// DELETE_DOMAIN_FROM_USER_ROLE_SUCCESS,
	// DELETE_DOMAIN_FROM_USER_ROLE_FAILED
} from '../actionTypes/user'
import { UPDATE_USER_PERMISSION } from '../actionTypes/auth'
import { createTwilioDevice, destroyTwilioDevice } from '../../services/helper'
import axios from 'axios'

export const updateUserPermission = ({ id, roleId, userId, isMarkAsCaller = false, phoneNo = '', isCallerAdmin = false, isBulkUpdate = false }) => (dispatch, getState) => {
	const { auth: { token, user }, domain: { currentDomain }, caller: { twilioDevice } } = getState()

	dispatch({
		type: GET_DOMAIN_USERS_START
	})

	return callPost(`/api/user/updateUserDomainPermission`, {
		id,
		roleId,
		isMarkAsCaller,
		phoneNo,
		userId,
		isCallerAdmin,
		isBulkUpdate
	}, token).then(async (res) => {
		if (parseInt(userId) === parseInt(user?.id)) {
			const roleName = roleId === 3 ? 'admin' : roleId === 2 ? 'moderator' : 'user'
			const userData = { ...user, isCaller: isMarkAsCaller, assignedPhoneNumber: phoneNo, roleId: roleId, roleName: roleName }
			dispatch({
				type: UPDATE_USER_PERMISSION,
				data: { isCaller: isMarkAsCaller, assignedPhoneNumber: phoneNo, roleId: roleId, roleName: roleName, isCallerAdmin: isCallerAdmin, isBulkUpdate: isBulkUpdate }
			})
			if (isMarkAsCaller && phoneNo) {
				createTwilioDevice(userData, dispatch)
			} else {
				destroyTwilioDevice(twilioDevice, dispatch)
			}
		}

		if (currentDomain?.id) {
			await dispatch(getUsersByDomain(currentDomain?.id))
		}
		return Promise.resolve(res['data'])
	}).catch((err) => {
		dispatch({
			type: GET_DOMAIN_USERS_FAILED
		})
		toast.show({
			title: 'Warning',
			description: 'Failed to update user permission in domain!',
		})
		return Promise.reject(err)
	})
}

export const deleteUser = ({ userId }) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/user/deleteUser`, {
		userId
	}, token).then(async (res) => {
		return Promise.resolve(res['data'])
	}).catch(err => {
		toast.show({
			title: 'Warning',
			description: 'Failed to delete user from user management!',
		})
		return Promise.reject(err)
	})
}

export const deleteDomainUser = ({ userId, domainId }) => (dispatch, getState) => {
	return callPost("/api/domain/deleteDomainUser", {
		userId,
		domainId
	}).then(async (res) => {
		return Promise.resolve(res['data'])
	}).catch(err => {
		toast.show({
			title: 'Warning',
			description: 'Failed to delete domain from user Roles!',
		})
		return Promise.reject(err)
	})
}

export const getUsersByDomain = (domainId) => (dispatch, getState) => {
	const { auth: { token } } = getState()

	dispatch({
		type: GET_DOMAIN_USERS_START
	})

	if (domainId) {
		return callGet(`/api/user/getUsersByDomain?domainId=${domainId}`, token).then(res => {
			dispatch({
				type: GET_DOMAIN_USERS_SUCCESS,
				data: res['data']
			})
			return Promise.resolve(res['data'])
		}).catch(err => {
			dispatch({
				type: GET_DOMAIN_USERS_FAILED
			})

			toast.show({
				title: 'Warning',
				description: 'Failed to get user list by domain!',
			})
			return Promise.reject(err)
		})
	}
}

export const getAllUsersInfo = () => (dispatch, getState) => {
	const { auth: { token } } = getState()

	dispatch({
		type: GET_ALL_USERS_START
	})

	callGet(`/api/user/getUserList`, token).then(res => {
		dispatch({
			type: GET_ALL_USERS_SUCCESS,
			data: res['data']
		})
	}).catch(err => {
		dispatch({
			type: GET_ALL_USERS_FAILED
		})

		toast.show({
			title: 'Warning',
			description: 'Failed to get user list!',
		})
	})
}

export const addRecentlyViewedResult = (resultData) => (dispatch, getState) => {
	const { auth: { token, user } } = getState()
	const { id } = user
	const { resultId, resultType } = resultData

	callPost(`/api/user/addRecentlyViewedResult`, {
		userId: id,
		resultId,
		resultType
	}, token).then(res => {
		dispatch(getRecentlyViewedSearchData())
	}).catch(err => {
		toast.show({
			title: 'Warning',
			description: 'Failed to add recently viewed result!',
		})
	})
}

export const getRecentlyViewedSearchData = () => (dispatch, getState) => {
	const { auth: { token } } = getState()

	dispatch({
		type: GET_RECENTLY_VIEWED_DATA_START
	})

	callGet(`/api/user/getRecentlyViewedSearchData`, token).then(res => {
		dispatch({
			type: GET_RECENTLY_VIEWED_DATA_SUCCESS,
			data: res['data']
		})
	}).catch(err => {
		dispatch({
			type: GET_RECENTLY_VIEWED_DATA_FAILED
		})

		toast.show({
			title: 'Warning',
			description: 'Failed to get recently viewed results data!',
		})
	})
}

export const updateRecentlyViewedResult = (resultData) => (dispatch, getState) => {
	const { auth: { token, user } } = getState()
	const { id } = user
	const { resultId, resultType } = resultData

	callPost(`/api/user/updateRecentlyViewedResult`, {
		userId: id,
		resultId,
		resultType
	}, token).then(res => {
		dispatch(getRecentlyViewedSearchData())
	}).catch(err => {
		toast.show({
			title: 'Warning',
			description: 'Failed to update recently viewed result!',
		})
	})
}

export const getRecentKeywords = () => (dispatch, getState) => {
	const { auth: { token } } = getState()

	dispatch({
		type: GET_RECENT_KEYWORDS_START
	})

	callGet(`/api/user/getRecentKeywords`, token).then(res => {
		dispatch({
			type: GET_RECENT_KEYWORDS_SUCCESS,
			data: res['data']
		})
	}).catch(err => {
		dispatch({
			type: GET_RECENT_KEYWORDS_FAILED
		})

		toast.show({
			title: 'Warning',
			description: 'Failed to get recent keywords!',
		})
	})
}

export const addRecentKeyword = (keywordData) => (dispatch, getState) => {
	const { auth: { token, user } } = getState()
	const { id } = user
	const { keyword, categoryType } = keywordData

	callPost(`/api/user/addRecentKeyword`, {
		userId: id,
		keyword,
		categoryType
	}, token).then(res => {
		dispatch(getRecentKeywords())
	}).catch(err => {
		toast.show({
			title: 'Warning',
			description: 'Failed to add recent keyword!',
		})
	})
}

export const updateRecentKeyword = (keywordData) => (dispatch, getState) => {
	const { auth: { token, user } } = getState()
	const { id } = user
	const { keyword, categoryType, rowId } = keywordData

	callPost(`/api/user/updateRecentKeyword`, {
		userId: id,
		keyword,
		categoryType,
		rowId
	}, token).then(res => {
		dispatch(getRecentKeywords())
	}).catch(err => {
		toast.show({
			title: 'Warning',
			description: 'Failed to update recent keyword data!',
		})
	})
}

export const getCallerUsers = () => (dispatch, getState) => {
	const { auth: { token } } = getState()

	dispatch({
		type: GET_CALLER_USERS_START
	})

	return callGet(`/api/user/getCallerUsers`, token).then(res => {
		dispatch({
			type: GET_CALLER_USERS_SUCCESS,
			data: res['data']
		})
		return Promise.resolve(res['data'])
	}).catch((err) => {
		toast.show({
			title: 'Warning',
			description: 'Failed to get caller users!',
		})
		dispatch({
			type: GET_CALLER_USERS_FAILED,
		})
		return Promise.reject(err)
	})
}

export const getAccessToken = (userName, assignedPhoneNumber, isCaller) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/caller/getAccessToken`, { userName, assignedPhoneNumber, isCaller }, token).then(res => {
		return Promise.resolve(res['data'])
	}).catch((err) => {
		toast.show({
			title: 'Warning',
			description: 'Failed to get caller users!',
		})
		return Promise.reject(err)
	})
}

export const twilioEndCall = (callerSID) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/caller/twilioEndCall`, { callerSID }, token).then(res => {
		return Promise.resolve(res['data'])
	}).catch((err) => {
		toast.show({
			title: 'Warning',
			description: 'Failed to get caller users!',
		})
		return Promise.reject(err)
	})
}


export const saveVoiceMail = ({ voiceMailType, voiceMailMessage, voiceMailDuration, voiceMailS3Url }) => (dispatch, getState) => {
	const { auth: { token } } = getState()
	return callPost(`/api/user/saveVoiceMail`, { voiceMailType, voiceMailMessage, voiceMailDuration, voiceMailS3Url  }, token).then(res => {
		return Promise.resolve(res['data'])
	}).catch((err) => {
		toast.show({
			title: 'Warning',
			description: 'Failed to get caller users!',
		})
		return Promise.reject(err)
	})
}


export const saveAndGetMediaAccessFile = (formData) => (dispatch, getState) => {
	const { auth: { token } } = getState()

	let apiUrl = ''
	if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
		apiUrl = `http://localhost:3001`
	} else if (process.env.NODE_ENV === 'review' ){
		apiUrl = window.location.origin
	} 
	return axios.post(apiUrl + `/api/user/saveAndGetMediaAccessFile`, formData, {
		headers: {
			"Authorization": `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	});
}